module.exports = __webpack_public_path__ + "static/media/4_Doklad_DVI_20150626.3170f02d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/4_Doklad_DVI_20150626.pdf
// module id = 187
// module chunks = 0